import axios from 'axios';

// Cliente axios central. En desarrollo usa el proxy de package.json (localhost:4000).
const api = axios.create({
  baseURL: '/api',
});

const listenersAILoading = new Set();
let peticionesIAActivas = 0;

const PATRONES_IA = [
  /^\/presupuestos-ia\//,
  /^\/almacen\/importar-documento(?:\/|$)/,
];

function normalizarRuta(url) {
  const ruta = String(url || '').split('?')[0].trim();
  if (!ruta) return '/';
  return ruta.startsWith('/') ? ruta : `/${ruta}`;
}

function esPeticionIA(config) {
  const ruta = normalizarRuta(config?.url);
  return PATRONES_IA.some((patron) => patron.test(ruta));
}

function notificarAILoading() {
  const activa = peticionesIAActivas > 0;
  for (const listener of listenersAILoading) {
    try {
      listener(activa);
    } catch (_) {
      // noop
    }
  }
}

function iniciarSeguimientoIA(config) {
  if (!esPeticionIA(config) || config.__trixIaTracked) return;
  config.__trixIaTracked = true;
  peticionesIAActivas += 1;
  notificarAILoading();
}

function finalizarSeguimientoIA(config) {
  if (!config?.__trixIaTracked) return;
  delete config.__trixIaTracked;
  peticionesIAActivas = Math.max(0, peticionesIAActivas - 1);
  notificarAILoading();
}

export function subscribeAILoading(listener) {
  if (typeof listener !== 'function') return () => {};
  listenersAILoading.add(listener);
  listener(peticionesIAActivas > 0);
  return () => {
    listenersAILoading.delete(listener);
  };
}

// Adjunta el token JWT a cada petición
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('trix_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  iniciarSeguimientoIA(config);
  return config;
});

// Si el token expira o es inválido, limpiar sesión
api.interceptors.response.use(
  (res) => {
    finalizarSeguimientoIA(res.config);
    return res;
  },
  (error) => {
    finalizarSeguimientoIA(error?.config);
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('trix_token');
      localStorage.removeItem('trix_empresa_activa');
      // Redirección suave al login si no estamos ya ahí
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
